import {
  deleteLocalSelectedFsrTab,
  deleteLocalSelectedOU,
  getSafeUrl,
  useGetSystemDataQuery,
  useUserSessionCheckQuery
} from '@monorepo/shared';
import AnimationOnScroll from '@monorepo/shared/components/AnimationOnScroll';
import { Check } from '@rsuite/icons';
import { CSSProperties, useEffect, useState } from 'react';
import { Button, Stack } from 'rsuite';
import { host, EnvConst, server } from '../../config/const';
import titleCard from '../../images/home/title_card.png';
import whatIsNewPic from '../../images/home/fsr_banner.png';
import dataCenter from '../../images/home/data_center.svg';
import pageOutWhiteSvg from '../../images/home/pageOutWhite.svg';
import {
  cloudLog,
  benefits,
  prod,
  useCase,
  whatIsNew,
  dataCenterLink,
  resourcesInfo,
  demoLink,
  solutionBriefLink
} from './homeCons';
const Home = () => {
  const { data: systemData, isSuccess: dataSuccess } = useGetSystemDataQuery({
    server: server
  });
  const { data: sessionData } = useUserSessionCheckQuery({ server: server });
  const [privacyUrl, setPrivacyUrl] = useState<string>('');
  const [releaseNoteUrl, setReleaseNoteUrl] = useState<string>('');
  const [termServiceUrl, setTermServiceUrl] = useState<string>(
    '/SD-CloudServices-FortiSOAR.pdf'
  );
  useEffect(() => {
    if (dataSuccess && systemData) {
      const data: Record<string, any> = systemData;
      setPrivacyUrl(data?.privacy_url);
      setReleaseNoteUrl(data?.release_note_url);
      if (data?.terms_of_service) {
        setTermServiceUrl(data?.terms_of_service);
      }
    }
  }, [dataSuccess, systemData]);

  useEffect(() => {
    if (sessionData?.active) {
      window.open(getSafeUrl(`${host}/login-redirect`), '_self');
    }
  }, [sessionData]);

  const login = () => {
    deleteLocalSelectedOU();
    deleteLocalSelectedFsrTab();
    if (window) {
      window.open(
        // getSafeUrl(`${EnvConst.auth_host}/ssologin/?next=${host}/organization`),
        getSafeUrl(
          `${EnvConst.auth_host}/ssologin/?next=${host}/login-redirect`
        ),
        '_self'
      );
    }
  };

  const register = () => {
    if (window) {
      window.open(getSafeUrl(`${EnvConst.registerUrl}`), '_self');
    }
  };

  const goToPremium = () => {
    if (window) {
      window.open(getSafeUrl(prod?.links?.goToPremium), '_blank');
    }
  };
  const goToVideo = () => {
    if (window) {
      window.open(getSafeUrl(prod?.links?.goToVideo), '_blank');
    }
  };

  const goToMore = () => {
    if (window) {
      window.open(getSafeUrl(prod?.links?.goToMore), '_blank');
    }
  };

  const goToDataCenterSevice = () => {
    if (window) {
      window.open(getSafeUrl(dataCenterLink), '_blank');
    }
  };
  return (
    <div className="home-page-container">
      <div className="nav-hoc">
        <div className="nav-content">
          <div className="header-logo">
            <img
              src={cloudLog}
              width="40"
              style={{ filter: 'invert(1)' }}
            ></img>
          </div>
          <div className="header-links">
            <a className="header-link" onClick={login}>
              Log in
            </a>
            <a className="header-link" onClick={register}>
              Create Account
            </a>
          </div>
        </div>
      </div>

      <div className="main">
        <div className="slp-container introduce">
          <div className="slp-content">
            <section className="title-container">
              <div className="title-content">
                <div className="title">
                  <h1>{prod?.name}</h1>
                  <p className="main-text">{prod?.desc}</p>
                  <Stack className="actions" spacing={32}>
                    <Button className="start-btn" onClick={register}>
                      <span className="link-desc">{' Create Account'}</span>
                    </Button>

                    <Button
                      appearance="link"
                      className="watch-demo"
                      onClick={goToVideo}
                    >
                      {`What is ${prod?.name}?`}
                    </Button>
                  </Stack>
                </div>
              </div>
              <div className="card-pic-container">
                <img src={titleCard} className="card-pic"></img>
              </div>
            </section>
          </div>
        </div>
        <div className="slp-container banner">
          <div className="slp-content">
            <div className="what-is-new-container">
              <div className="what-is-new">
                <div className="what-is-new-title">
                  <div className="core-title">
                    <div>{`${whatIsNew?.title} ${prod?.name}`}</div>
                    <div className="sub-title">{whatIsNew?.subtitle}</div>
                  </div>
                  <div className="title-desc">{whatIsNew?.desc}</div>
                </div>
                <Button
                  className="what-is-new-btn"
                  onClick={() => {
                    window &&
                      window.open(
                        getSafeUrl(whatIsNew?.links?.[0]?.link),
                        '_blank'
                      );
                  }}
                >
                  <span className="link-desc">
                    {whatIsNew?.links?.[0]?.title}
                  </span>
                </Button>
              </div>
              <img src={whatIsNewPic} className="what-is-new-pic" alt="" />
            </div>
          </div>
        </div>

        <div className="slp-container benefits-tiles">
          <div className="slp-content">
            <div className="slp-header">
              <h1 className="slp-header-title">{'Powerful Benefits'}</h1>
            </div>
            <div className="benefits">
              {benefits?.length ? (
                benefits.map((obj: Record<string, any>, index: number) => (
                  <div className="benefit-container" key={index}>
                    <div className="benefit-header">
                      <div className="benefit-icon">
                        <img src={obj?.icon} />
                      </div>
                      <div className="benefit-title">{obj?.text}</div>
                    </div>
                    <p className="benefit-content">{obj?.desc}</p>
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>

        <div className="slp-container data-center">
          <div className="slp-content">
            <div className="slp-header">
              <h1 className="slp-header-title">
                {'Service Availability Across'}
              </h1>
              <h1 className="slp-header-title">
                {'Multiple Data Centres Globally'}
              </h1>
            </div>
            <div className="data-center-container">
              <img src={dataCenter}></img>
              {/* <iframe
                src={dataCenterLink}
                id="status-iframe"
                scrolling="no"
              ></iframe> */}
            </div>
            <div className="data-center-btn-container">
              <Button
                className="data-center-btn"
                onClick={goToDataCenterSevice}
              >
                <span className="data-center-btn-text">{`Learn more about the service`}</span>
                <img src={pageOutWhiteSvg} />
              </Button>
            </div>
          </div>
        </div>

        <div className="slp-container summary">
          <div className="slp-content">
            <div className="summary-card">
              <div className="summary-title">500</div>
              <div className="summary-content">
                {'Multi-vendor integrations'}
              </div>
            </div>
            <div className="summary-card">
              <div className="summary-title">800</div>
              <div className="summary-content">{'Pre-built playbooks'}</div>
            </div>
            <div className="summary-card">
              <div className="summary-title">300</div>
              <div className="summary-content">
                {'Enterprise/MSSP customers'}
              </div>
            </div>
          </div>
        </div>

        <div className="slp-container usecase-tiles">
          <div className="slp-content">
            <div className="slp-header">
              <h1 className="slp-header-title">{'FortiSOAR Use Cases'}</h1>
            </div>
            <div className="usecase">
              {useCase?.length ? (
                useCase.map((obj: Record<string, any>, idx: number) => (
                  <div className="usecase-container" key={idx}>
                    <div className="usecase-header">
                      <div className="usecase-icon">
                        <img src={obj?.icon} />
                      </div>
                      <div className="usecase-title">{obj?.text}</div>
                    </div>
                    <p className="usecase-content">{obj?.desc}</p>
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>

        <div className="slp-container resources-info-tiles">
          <div className="slp-content">
            <div className="slp-header">
              <h1 className="slp-header-title">{'Resources'}</h1>
            </div>
            <div className="resources-info-container">
              {resourcesInfo?.length ? (
                resourcesInfo.map((obj: Record<string, any>, index: number) => (
                  <div className="resources-info-card" key={index}>
                    <div className="resources-info-header">
                      <div className="resources-info-title">{obj?.title}</div>
                    </div>
                    <p className="resources-info-content">{obj?.content}</p>
                    <Button
                      className="resources-info-btn"
                      appearance="link"
                      onClick={() => {
                        window &&
                          window.open(getSafeUrl(obj?.btn?.link), '_blank');
                      }}
                    >
                      <p>{obj?.btn?.text}</p>
                      <img src={obj?.btn?.icon} />
                    </Button>
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>

        <div className="slp-container demo-tiles">
          <div className="slp-content demo-content">
            <div className="slp-header">
              <h1 className="slp-header-title">
                {
                  'FortiSOAR unifies and optimizes the SOC activities that protect against attacks'
                }
              </h1>
            </div>
            <div className="demo-btn-container">
              <Button
                size="lg"
                appearance="primary"
                className="demo-btn"
                onClick={() => {
                  window && window.open(getSafeUrl(demoLink), '__blank');
                }}
              >
                {'Get Free Product Demo'}
              </Button>
              <Button
                size="lg"
                appearance="primary"
                className="demo-btn download-btn"
                onClick={() => {
                  window &&
                    window.open(getSafeUrl(solutionBriefLink), '__blank');
                }}
              >
                {'Download Solution Brief'}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <footer className="base-footer">
        <div className="container">
          <div className="footer-logo">
            <i className="icon-prelogin-fortinet"></i>
          </div>
          <div className="footer-bottom">
            <div className="footer-links">
              <div className="link-wrapper">
                <a href={termServiceUrl} target="_blank">
                  Terms of Service
                </a>
              </div>
              <div className="link-wrapper">
                <a href={privacyUrl} target="_blank">
                  Privacy Policy
                </a>
              </div>
              <div className="link-wrapper">
                <a href={releaseNoteUrl} target="_blank">
                  Release Notes
                </a>
              </div>
            </div>
            <div className="footer-copy">
              {`Copyright © ${new Date().getFullYear()} Fortinet, Inc. All Rights Reserved`}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
